import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/shared/v1/target_group.types';
import {COLORS} from '@aboutyou/ui-components';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useSelectedDiscount} from './useSelectedDiscount';

export function useSelectedDiscountColor(): string | undefined;

export function useSelectedDiscountColor<T extends boolean>({
  asGradient,
}: {
  asGradient: T;
}): T extends true
  ?
      | string
      | undefined
      | {
          startingGradientColor: string;
          endingGradientColor: string;
        }
  : string | undefined;

export function useSelectedDiscountColor({
  asGradient,
}: {asGradient?: boolean} = {}) {
  const selectedDiscount = useSelectedDiscount();
  const {targetGroup} = useSelectedTargetGroup();

  if (!selectedDiscount) {
    return;
  }

  if (selectedDiscount?.discount?.$case === 'personalDiscount') {
    if (asGradient) {
      return {
        startingGradientColor: COLORS.StartGradientSale,
        endingGradientColor: COLORS.EndGradientSale,
      };
    }
    return COLORS.PersonalDiscount;
  }

  if (targetGroup === TargetGroup.MALE) {
    return selectedDiscount.discount?.priceReductionCampaign.femaleTopBanner
      .backgroundColor;
  } else {
    return selectedDiscount.discount?.priceReductionCampaign.maleTopBanner
      .backgroundColor;
  }
}
